// extracted by mini-css-extract-plugin
module.exports = {"transcriptOverlay":"viewer-video-buttons_transcriptOverlay_uGw"};